/**
 * @desc 查询中台系统订单退货单品明细
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/loadBySoOrderNos`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
